/**
 * ROLVEA Cart Drawer v3 — behaviour.
 * - Cosmetic scarcity and delivery calculation.
 * - Horizontal upsell hint handling.
 * - Automatic application of the configured manual discount code when the
 *   server-rendered offer block reports that its quantity condition is met.
 * - Re-initialisation after Shopify/theme AJAX cart renders.
 * - 21/09/2026: le righe aggiunte dalle card del drawer portano properties._src ('drawer' | 'pdp')
 *   così negli ordini si legge da dove è arrivato il pack (misura del cross-sell). Nascosta in cassa (underscore).
 */
(function () {
  'use strict';
  if (window.RolveaCartV2) return;

  var DRAWER_ID = 'CartDrawer';
  var DONE = 'data-rv2-done';
  var applyingDiscounts = Object.create(null);
  var reduceMotion = false;
  try { reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}

  var FALLBACK_DAYS = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];
  var FALLBACK_MONTHS = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

  function toInt(v, fallback) { var n = parseInt(v, 10); return isNaN(n) ? fallback : n; }
  function attr(el, name) { var v = el.getAttribute(name); return v == null ? '' : v; }
  function splitLabels(str, fallback) {
    if (!str) return fallback;
    var arr = str.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    return arr.length ? arr : fallback;
  }
  function esc(s) {
    return String(s).replace(/[&<>\"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;' }[c]; });
  }
  function ssGet(key) {
    try { var v = window.sessionStorage.getItem(key); return v == null ? null : parseInt(v, 10); } catch (e) { return null; }
  }
  function ssSet(key, val) { try { window.sessionStorage.setItem(key, String(val)); } catch (e) {} }
  function ssRemove(key) { try { window.sessionStorage.removeItem(key); } catch (e) {} }

  function fillScarcity(scope) {
    var nodes = scope.querySelectorAll('[data-rv2-scarcity]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute(DONE)) continue;
      var min = toInt(attr(el, 'data-min'), 2);
      var max = toInt(attr(el, 'data-max'), 6);
      if (max < min) { var tmp = min; min = max; max = tmp; }
      var variantId = attr(el, 'data-variant-id') || attr(el, 'data-rv2-scarcity');
      var variantTitle = attr(el, 'data-variant-title');
      var key = 'rolvea_scarcity_' + (variantId || variantTitle || 'x');
      var n = ssGet(key);
      if (n === null || isNaN(n)) { n = min + Math.floor(Math.random() * (max - min + 1)); ssSet(key, n); }
      var prefix = attr(el, 'data-variant-prefix') || ' in ';
      var variantSuffix = (variantTitle && variantTitle !== 'Default Title') ? (prefix + variantTitle) : '';
      var template = attr(el, 'data-template') || el.textContent || 'Solo [n] rimasti[variant]';
      el.textContent = template.replace(/\[n\]/g, String(n)).replace(/\[variant\]/g, variantSuffix);
      el.setAttribute(DONE, '1');
    }
  }

  function addDays(base, n, skipWeekends) {
    var d = new Date(base.getTime());
    if (!skipWeekends) { d.setDate(d.getDate() + n); return d; }
    var added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); var dow = d.getDay(); if (dow !== 0 && dow !== 6) added++; }
    return d;
  }
  function fmtDate(date, dayLabels, monthLabels, withMonth) {
    var s = dayLabels[date.getDay()] + ' ' + date.getDate();
    if (withMonth) s += ' ' + monthLabels[date.getMonth()];
    return s;
  }
  function fillDelivery(scope) {
    var nodes = scope.querySelectorAll('[data-rv2-delivery]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute(DONE)) continue;
      var minDays = toInt(attr(el, 'data-min-days'), 3);
      var maxDays = toInt(attr(el, 'data-max-days'), 6);
      if (maxDays < minDays) { var t = minDays; minDays = maxDays; maxDays = t; }
      var excludeWeekends = !/^(false|0|no|off)$/i.test(attr(el, 'data-exclude-weekends'));
      var cutoff = attr(el, 'data-cutoff') || '23:59';
      var template = attr(el, 'data-template') || el.textContent || 'Order by [cutoff] → estimated delivery [start_date] – [end_date]';
      var dayLabels = splitLabels(attr(el, 'data-day-labels'), FALLBACK_DAYS);
      var monthLabels = splitLabels(attr(el, 'data-month-labels'), FALLBACK_MONTHS);
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var start = addDays(today, minDays, excludeWeekends);
      var end = addDays(today, maxDays, excludeWeekends);
      if (end < start) end = start;
      var sameMonth = start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth();
      var startStr = fmtDate(start, dayLabels, monthLabels, !sameMonth);
      var endStr = fmtDate(end, dayLabels, monthLabels, true);
      el.innerHTML = template
        .replace(/\[cutoff\]/g, '<strong class="rv2-delivery__cutoff">' + esc(cutoff) + '</strong>')
        .replace(/\[start_date\]/g, '<strong class="rv2-delivery__date">' + esc(startStr) + '</strong>')
        .replace(/\[end_date\]/g, '<strong class="rv2-delivery__date">' + esc(endStr) + '</strong>');
      el.setAttribute(DONE, '1');
    }
  }

  function wireOne(container, hint) {
    if (!container || container.hasAttribute(DONE)) return;
    container.setAttribute(DONE, '1');
    if (!hint) return;
    var onScroll = function () {
      if (container.scrollLeft > 8) { hint.classList.add('rv2-carousel-hint--hidden'); container.removeEventListener('scroll', onScroll); }
    };
    container.addEventListener('scroll', onScroll, { passive: true });
  }
  function wireCarousel(scope) {
    var tracks = scope.querySelectorAll('[data-rv2-upsell-track]');
    for (var i = 0; i < tracks.length; i++) {
      var root = tracks[i].closest ? tracks[i].closest('.rv2-upsell') : tracks[i].parentNode;
      wireOne(tracks[i], root && root.querySelector ? root.querySelector('[data-rv2-upsell-hint]') : null);
    }
    var containers = scope.querySelectorAll('.cart-drawer-upsells-container');
    for (var j = 0; j < containers.length; j++) {
      var c = containers[j];
      var title = (c.querySelector && c.querySelector('.upsell__outside-title')) || (c.parentNode && c.parentNode.querySelector ? c.parentNode.querySelector('.upsell__outside-title') : null);
      wireOne(c, title);
    }
  }

  function walletPriority(name, appleDevice) {
    var appleOrder = ['shop_pay', 'apple_pay', 'paypal', 'google_pay'];
    var defaultOrder = ['shop_pay', 'google_pay', 'paypal', 'apple_pay'];
    var order = appleDevice ? appleOrder : defaultOrder;
    var index = order.indexOf(String(name || '').toLowerCase());
    return index === -1 ? order.length + 1 : index;
  }

  /**
   * Shopify renders the cart wallets from the public `wallet-configs` attribute
   * on <shopify-accelerated-checkout-cart>. Keep the three most useful wallets
   * so the component has enough room to remain in its horizontal cart layout,
   * including inside the narrow mobile drawer.
   */
  function limitExpressWallets(scope) {
    var wallets = scope.querySelectorAll('shopify-accelerated-checkout-cart[wallet-configs]:not([data-rv2-wallet-limit])');
    var appleDevice = false;
    try {
      appleDevice = !!window.ApplePaySession || /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent || '');
    } catch (e) {}

    for (var i = 0; i < wallets.length; i++) {
      var el = wallets[i];
      var configs;
      try { configs = JSON.parse(attr(el, 'wallet-configs')); } catch (e) { configs = null; }
      if (!Array.isArray(configs) || !configs.length) {
        el.setAttribute('data-rv2-wallet-limit', 'unavailable');
        continue;
      }

      if (configs.length <= 3) {
        el.setAttribute('data-rv2-wallet-limit', String(configs.length));
        continue;
      }

      configs = configs.map(function (config, originalIndex) {
        return { config: config, originalIndex: originalIndex };
      }).sort(function (a, b) {
        var pa = walletPriority(a.config && a.config.name, appleDevice);
        var pb = walletPriority(b.config && b.config.name, appleDevice);
        return pa === pb ? a.originalIndex - b.originalIndex : pa - pb;
      }).slice(0, 3).map(function (entry) { return entry.config; });

      var checkoutDefined = false;
      try {
        checkoutDefined = !!(window.customElements && window.customElements.get('shopify-accelerated-checkout-cart'));
      } catch (e) {}

      var target = el;
      if (checkoutDefined) {
        target = el.cloneNode(true);
      }
      target.setAttribute('wallet-configs', JSON.stringify(configs));
      target.setAttribute('data-rv2-wallet-limit', String(configs.length));

      var skeletonCells = target.querySelectorAll('[data-shopify-buttoncontainer] > *, [role="list"] > *');
      for (var c = skeletonCells.length - 1; c >= configs.length; c--) {
        if (skeletonCells[c] && skeletonCells[c].parentNode) skeletonCells[c].parentNode.removeChild(skeletonCells[c]);
      }

      if (checkoutDefined && el.parentNode) el.parentNode.replaceChild(target, el);
    }
  }

  function requestKey(node, code) {
    return 'rv2_discount_' + encodeURIComponent(attr(node, 'data-cart-token') || 'cart') + '_' + encodeURIComponent(code) + '_' + (attr(node, 'data-qualifying-qty') || '0');
  }
  function applyEligibleDiscounts(scope) {
    var nodes = scope.querySelectorAll('[data-rv2-offer][data-auto-apply="true"]');
    for (var i = 0; i < nodes.length; i++) {
      (function (node) {
        var eligible = attr(node, 'data-discount-eligible') === 'true';
        var applied = attr(node, 'data-discount-applied') === 'true';
        var code = attr(node, 'data-discount-code').trim();
        if (!eligible || applied || !code) return;

        var key = requestKey(node, code);
        if (applyingDiscounts[key] || ssGet(key)) return;
        applyingDiscounts[key] = true;
        ssSet(key, Date.now());
        node.setAttribute('data-discount-requested', 'true');

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            discount: code,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        }).then(function (response) {
          if (!response.ok) throw new Error('Discount update failed: ' + response.status);
          return response.json();
        }).then(function (data) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
            drawer.renderContents(data, true);
          }
          try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data, source: 'rolvea-discount' } })); } catch (e) {}
        }).catch(function () {
          ssRemove(key);
          node.removeAttribute('data-discount-requested');
        }).finally(function () {
          delete applyingDiscounts[key];
        });
      })(nodes[i]);
    }
  }


  /* =========================================================================
     TANGA 5+5 — sync della riga OMAGGIO (12/09/2026)
     Il pack omaggio (prodotto `tanga-comfortcotton-5-in-omaggio`, azzerato in cassa
     dallo sconto automatico «Pagane 5, ricevine 10») deve avere, taglia per taglia e
     colore per colore, la STESSA quantita' del pack pagato. La PDP li aggiunge insieme;
     qui si copre tutto il resto: +/- e cestino nel drawer, quick-add, carrelli vecchi.
     Regola: per ogni titolo variante, omaggio = pagato. Pagato assente -> omaggio a 0.
     Le righe omaggio portano `_gift` (come i regali del tema: fuori dai conteggi della
     barra premi). Nessuna cifra qui: ids letti da /products/<omaggio>.js.
     ========================================================================= */
  var TG_PAID = 'tanga-comfortcotton-antibatterico-pagane-5-ricevine-10';
  var TG_OM = 'tanga-comfortcotton-5-in-omaggio';
  /* 16/09/2026 — FAMIGLIA PURELINE (best seller Amelie importati: slip, tanga pizzo, invisibili, vita media, sexy,
     vita alta). Stessa meccanica del tanga, ma le coppie pagato→omaggio non sono cablate qui: snippets/cart-drawer.liquid
     stampa [data-rv-tg-pairs] = { "<handle pagato>": "<handle omaggio>" } per i prodotti in carrello (metafield JSON
     custom.pureline: `om` sul pagato, `paid_of` sull'omaggio). Il tanga resta come fallback. */
  var TG_PAIRS_DEFAULT = {}; TG_PAIRS_DEFAULT[TG_PAID] = TG_OM;
  function tgPairs() {
    var m = {}, k;
    for (k in TG_PAIRS_DEFAULT) m[k] = TG_PAIRS_DEFAULT[k];
    var nodes = document.querySelectorAll('[data-rv-tg-pairs]');
    for (var i = 0; i < nodes.length; i++) {
      try { var j = JSON.parse(nodes[i].textContent || '{}'); for (k in j) if (j[k]) m[k] = j[k]; } catch (e) {}
    }
    return m;
  }
  function tgPaidOf(handle, pairs) { for (var k in pairs) if (pairs[k] === handle) return k; return null; }
  /* Spedizione gratis da 2 pack = codice sconto "spedizione" applicato da qui (non un profilo
     di spedizione separato: due profili sommavano 6,90 + 6,90 sui carrelli misti sotto i 50 EUR,
     misurato il 12/09). Il codice ha quantita' minima 4 (2 pack pagati + 2 omaggio): sotto,
     Shopify lo marca applicable:false e qui viene tolto. Gli altri codici della cliente restano.
     ⚠️ applicable:false compare ANCHE quando il carrello supera i 79 EUR (spedizione gia' gratis
     dal profilo): non e' un conflitto con gli sconti automatici — misurato il 12/09 dopo un'ora
     di esperimenti sbagliati. */
  var TG_SHIP_CODE = '2PACK';
  /* 16/09/2026 — cross-sell al carrello (snippets/rolvea-cart-upsell.liquid v21, card [data-rv-tgx]): con 1 pack + un
     capo di TG_XS sotto i 79 EUR la spedizione gratis e' il codice TANGAPLUS (quantita' minima 3 = pack pagato + omaggio
     + capo). Da 2 pack in su resta il 2PACK; mai tutti e due insieme. */
  var TG_XS = ['leggings-classic-seconda-pelle', 'reggiseno-classic-seconda-pelle'];
  var TG_PLUS_CODE = 'TANGAPLUS';
  /* Il «prezzo carrello» dei leggings (−5 €) e' il codice prodotto TANGALEG, applicato quando c'e' almeno 1 pack +
     i leggings, qualunque sia il totale. NON e' un BxGy automatico: provato il 16/09, un secondo BxGy con lo stesso
     pack come «buy» ruba il pack al «Pagane 5, ricevine 10» e l'omaggio torna a 29,95 (una sola riga puo' fare
     da «buy» per un solo BxGy). */
  var TG_LEG_CODE = 'TANGALEG', TG_LEG_HANDLE = 'leggings-classic-seconda-pelle';
  /* 16/09/2026 - OFFERTE MULTIPACK (slip modellante 360 / reggiseno comfort / calze compressione: prodotti
     copiati dai competitor, livelli 1+1 / 2+2 / 3x2 / 2+3 con 'spedizione gratuita' promessa in pagina).
     Sotto i 79 EUR la spedizione gratis e' il codice OFFERTA2 (classe spedizione, quantita' minima 2)
     applicato da qui quando nel carrello ci sono >= 2 pezzi di questi prodotti (handle in MP_HANDLES);
     sopra i 79 EUR e' gia' gratis dal profilo e il codice viene tolto. Mai insieme a 2PACK/TANGAPLUS:
     un solo codice spedizione per volta (il tanga ha la precedenza, e' lo stesso beneficio). */
  var MP_HANDLES = ["slip-modellante-vita-alta-controllo-addome-senza-cuciture", "calze-a-compressione-comfort-15-20-mmhg",
                    "collant-termici-modellanti-effetto-pelle-nuda"];
  /* 03/10/2026 - collant termici aggiunti su decisione di Michele: spedizione gratis con 2+ paia (il pack da 3 = 78 EUR,
     1 sotto la soglia 79). Un paio solo paga 6,90 come da soglia store. */;
  /* 27/09/2026 - "reggiseno-comfort-modellante-senza-ferretto" TOLTO da MP_HANDLES su decisione di Michele:
     il reggiseno paga la spedizione come da soglia store (2 pz = 44,90 -> 6,90; 4 pz = 79,90 -> gratis dal
     profilo, 0,90 sopra soglia). Slip e calze restano. Non rimetterlo senza il suo OK. */
  var MP_SHIP_CODE = 'OFFERTA2';
  var tgSeen = false;
  var tgSyncing = false, tgOmMapCache = {}, tgReloaded = false;
  function tgRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/'; }
  function tgJson(url, body) {
    var opts = body ? { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    return fetch(url, opts).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function tgOmMap(omHandle) {
    omHandle = omHandle || TG_OM;
    if (tgOmMapCache[omHandle]) return Promise.resolve(tgOmMapCache[omHandle]);
    return tgJson(tgRoot() + 'products/' + omHandle + '.js').then(function (p) {
      var m = {}; (p.variants || []).forEach(function (v) { m[v.title] = v.id; });
      tgOmMapCache[omHandle] = m; return m;
    });
  }
  function tgNeedsSync(scope) {
    var root = document.querySelector('cart-items') ? document : scope;
    if (root.querySelector('.cart-item--product-' + TG_PAID) || root.querySelector('.cart-item--product-' + TG_OM)) return true;
    if (root.querySelector('.cart-item[class*="-in-omaggio"]')) return true;
    var pairs = tgPairs();
    for (var ph in pairs) if (root.querySelector('.cart-item--product-' + ph)) return true;
    for (var i = 0; i < TG_XS.length; i++) if (root.querySelector('.cart-item--product-' + TG_XS[i])) return true;
    for (var k = 0; k < MP_HANDLES.length; k++) if (root.querySelector('.cart-item--product-' + MP_HANDLES[k])) return true;
    return false;
  }
  function tgRender(data) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !data || !data.sections) return;
    if (drawer.classList.contains('active') && typeof drawer.renderContents === 'function') { drawer.renderContents(data, true); return; }
    try {
      var html = data.sections['cart-drawer'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(DRAWER_ID), cur = document.getElementById(DRAWER_ID);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      }
      var bubble = data.sections['cart-icon-bubble'], bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubble && bubbleEl) bubbleEl.innerHTML = new DOMParser().parseFromString(bubble, 'text/html').body.innerHTML;
    } catch (e) {}
  }
  function tgCodeState(cart) {
    var codes = (cart && cart.discount_codes) || [], others = [], has2 = false, hasPlus = false, hasLeg = false, hasMp = false;
    codes.forEach(function (c) {
      var u = String(c.code).toUpperCase();
      if (u === TG_SHIP_CODE) has2 = true; else if (u === TG_PLUS_CODE) hasPlus = true; else if (u === TG_LEG_CODE) hasLeg = true; else if (u === MP_SHIP_CODE) hasMp = true; else others.push(c.code);
    });
    return { has2: has2, hasPlus: hasPlus, hasLeg: hasLeg, hasMp: hasMp, others: others };
  }
  var tgSyncAgain = false;
  function tgSync() {
    if (tgSyncing) { tgSyncAgain = true; return; }
    tgSyncing = true; tgSyncAgain = false;
    tgJson(tgRoot() + 'cart.js').then(function (cart) {
      /* paid[<handle pagato>][titolo variante] = qta · om[<handle pagato>][titolo variante] = righe omaggio.
         `packs` somma i pack di TUTTA la famiglia: 1 tanga + 1 slip = 2 pack → 2PACK (min. 4 articoli) e «3 pack: -10%» valgono
         sul mix, come gli sconti (estesi a tutti i pagati/omaggio della famiglia il 16/09). */
      var pairs = tgPairs();
      var paid = {}, om = {}, items = (cart && cart.items) || [], packs = 0, xs = false, leg = false, mp = 0;
      items.forEach(function (it) {
        var ph;
        if (pairs[it.handle]) { var f = paid[it.handle] = paid[it.handle] || {}; f[it.variant_title] = (f[it.variant_title] || 0) + it.quantity; packs += it.quantity; }
        else if ((ph = tgPaidOf(it.handle, pairs))) { var o = om[ph] = om[ph] || {}; (o[it.variant_title] = o[it.variant_title] || []).push(it); }
        else if (TG_XS.indexOf(it.handle) !== -1) { xs = true; if (it.handle === TG_LEG_HANDLE) leg = true; }
        else if (MP_HANDLES.indexOf(it.handle) !== -1) mp += it.quantity;
      });
      /* Sopra la soglia del profilo (79 EUR) la spedizione e' gia' gratis e Shopify marca il codice
         "non applicabile": non si applica (e si toglie) per non far comparire un avviso in cassa. */
      var code = tgCodeState(cart), codeOp = null, under = (cart.total_price || 0) < 7900;
      var want2 = packs >= 2 && under, wantPlus = !want2 && packs >= 1 && xs && under, wantLeg = packs >= 1 && leg;
      var wantMp = !want2 && !wantPlus && mp >= 2 && under;
      if (want2 !== code.has2 || wantPlus !== code.hasPlus || wantLeg !== code.hasLeg || wantMp !== code.hasMp) {
        var list = code.others.slice();
        if (want2) list.push(TG_SHIP_CODE);
        if (wantPlus) list.push(TG_PLUS_CODE);
        if (wantLeg) list.push(TG_LEG_CODE);
        if (wantMp) list.push(MP_SHIP_CODE);
        codeOp = { discount: list.join(',') };
      }
      var changes = [], adds = [];
      Object.keys(om).forEach(function (ph) {
        var fam = om[ph], fp = paid[ph] || {};
        Object.keys(fam).forEach(function (t) {
          var want = fp[t] || 0, lines = fam[t], have = 0;
          lines.forEach(function (l) { have += l.quantity; });
          if (have !== want) lines.forEach(function (l, i) { changes.push({ id: l.key, quantity: i === 0 ? want : 0 }); });
        });
      });
      Object.keys(paid).forEach(function (ph) {
        var fp = paid[ph], fo = om[ph] || {};
        Object.keys(fp).forEach(function (t) { if (!fo[t] && fp[t] > 0) adds.push({ om: pairs[ph], title: t, quantity: fp[t] }); });
      });
      if (!changes.length && !adds.length && !codeOp) return null;
      var chain = Promise.resolve();
      if (codeOp) chain = chain.then(function () { return tgJson(tgRoot() + 'cart/update.js', codeOp); });
      changes.forEach(function (c) { chain = chain.then(function () { return tgJson(tgRoot() + 'cart/change.js', c); }); });
      if (adds.length) {
        var omHandles = [];
        adds.forEach(function (a) { if (a.om && omHandles.indexOf(a.om) === -1) omHandles.push(a.om); });
        chain = chain.then(function () { return Promise.all(omHandles.map(function (h) { return tgOmMap(h).then(function (m) { return [h, m]; }); })); }).then(function (maps) {
          var byOm = {}; maps.forEach(function (p) { byOm[p[0]] = p[1]; });
          var list = [];
          adds.forEach(function (a) { var m = byOm[a.om] || {}; if (m[a.title]) list.push({ id: m[a.title], quantity: a.quantity, properties: { _gift: 'true' } }); });
          return list.length ? tgJson(tgRoot() + 'cart/add.js', { items: list }) : null;
        });
      }
      var refresh = function () {
        return tgJson(tgRoot() + 'cart/update.js', { updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }).then(tgRender);
      };
      /* secondo render dopo 700 ms: se il tema stava gia' rispondendo a un suo /cart/change,
         il suo render (piu' vecchio) arriverebbe dopo il nostro e mostrerebbe l'omaggio non
         ancora allineato. Il secondo passaggio riporta il drawer allo stato vero. */
      return chain.then(refresh).then(function () {
        setTimeout(function () { refresh().catch(function () {}); }, 700);
        /* pagina /cart: le righe della pagina non sono nel drawer, si ricarica una volta sola. */
        if (document.querySelector('cart-items') && !tgReloaded && (changes.length || adds.length)) {
          var last = ssGet('rv_tg_reload') || 0;
          if (Date.now() - last > 15000) { tgReloaded = true; ssSet('rv_tg_reload', Date.now()); window.location.reload(); }
        }
      });
    }).catch(function () {}).then(function () { tgSyncing = false; if (tgSyncAgain) { tgSyncAgain = false; tgSync(); } });
  }

  /* --- V7 (21/09/2026 sera) riserva 10 minuti + stock Pureline nella riga (numero della PDP) ---
     rsv: parte al primo render con articoli, riparte quando il numero di righe SALE (nuovo pack aggiunto), scade a 0 e sparisce.
     L'orologio scrive nel text node (.data) e non nel textContent: cambiare textContent = childList = MutationObserver = init ogni secondo. */
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  var rsv = { start: 0, mins: 10, timer: null };
  function rsvInit(scope) {
    var strip = scope.querySelector('[data-rv-rsv]');
    if (!strip) return;
    rsv.mins = toInt(attr(strip, 'data-min'), 10);
    var count = scope.querySelectorAll('.cart-item').length;
    var start = parseInt(lsGet('rv_rsv_start') || '0', 10) || 0;
    var prev = parseInt(lsGet('rv_rsv_count') || '0', 10) || 0;
    var now = Date.now();
    if (!start || count > prev || now - start > 6 * 3600000) { start = now; lsSet('rv_rsv_start', String(start)); }
    lsSet('rv_rsv_count', String(count));
    rsv.start = start;
    rsvTick();
    if (!rsv.timer) rsv.timer = setInterval(function () { try { rsvTick(); } catch (e) {} }, 1000);
  }
  function setData(el, t) { var n = el.firstChild; if (n && n.nodeType === 3) { if (n.data !== t) n.data = t; } else { el.textContent = t; } }
  function rsvTick() {
    var scope = document.getElementById(DRAWER_ID) || document;
    var strip = scope.querySelector('[data-rv-rsv]');
    if (!strip || !rsv.start) return;
    var left = rsv.mins * 60 - Math.floor((Date.now() - rsv.start) / 1000);
    var pill = scope.querySelector('[data-rv-rsv-pill]');
    if (left <= 0) { if (!strip.hidden) strip.hidden = true; if (pill && !pill.hidden) pill.hidden = true; return; }
    if (strip.hidden) strip.hidden = false;
    if (pill && pill.hidden) pill.hidden = false;
    var t = pad2(Math.floor(left / 60)) + ':' + pad2(left % 60);
    var clocks = scope.querySelectorAll('[data-rv-rsv-clock]');
    for (var i = 0; i < clocks.length; i++) setData(clocks[i], t);
    var fill = scope.querySelector('[data-rv-rsv-fill]');
    if (fill) { var w = Math.max(0, Math.min(100, left / (rsv.mins * 60) * 100)).toFixed(1) + '%'; if (fill.style.width !== w) fill.style.width = w; }
  }
  function plStock(scope) {
    var nodes = scope.querySelectorAll('[data-rv-pl-stk]');
    if (!nodes.length) return;
    var d = new Date(), day = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute(DONE)) continue;
      var pid = attr(el, 'data-pid'), size = attr(el, 'data-size'), n = toInt(attr(el, 'data-base'), 8);
      var store = null;
      try { store = JSON.parse(lsGet('rv_plu_' + pid + '_' + day) || 'null'); } catch (e) { store = null; }
      if (store && size && typeof store[size] === 'number') n = store[size];
      var tpl = attr(el, 'data-tpl') || '[n]';
      var t = el.querySelector('[data-rv-pl-stk-t]');
      if (t) t.textContent = tpl.replace(/\[n\]/g, String(n));
      el.setAttribute(DONE, '1');
    }
  }

  function init() {
    var scope = document.getElementById(DRAWER_ID) || document;
    limitExpressWallets(scope);
    fillScarcity(scope);
    fillDelivery(scope);
    plStock(scope);
    rsvInit(scope);
    wireCarousel(scope);
    applyEligibleDiscounts(scope);
    tgxReveal(scope);
    tgpWire(scope);
    tgpFlash(scope);
    /* tgSeen: se le righe tanga/cross-sell c'erano e ora non ci sono piu' (cliente le ha tolte), un ultimo giro
       toglie i codici 2PACK/TANGAPLUS rimasti sul carrello. */
    if (tgNeedsSync(scope)) { tgSeen = true; tgSync(); }
    else if (tgSeen) { tgSeen = false; tgSync(); }
  }

  var OBS_OPTS = { childList: true, subtree: true };
  var observer = null;
  var debounceTimer = null;
  function scheduleInit() { if (debounceTimer) clearTimeout(debounceTimer); debounceTimer = setTimeout(runInit, 120); }
  function runInit() {
    var drawer = document.getElementById(DRAWER_ID);
    if (observer) observer.disconnect();
    try { init(); } catch (e) {}
    if (drawer) { if (!observer) observer = new MutationObserver(scheduleInit); observer.observe(drawer, OBS_OPTS); }
    var pageItems = document.querySelector('cart-items');
    if (pageItems && observer) observer.observe(pageItems, OBS_OPTS);
  }

  if (document.readyState !== 'loading') runInit(); else document.addEventListener('DOMContentLoaded', runInit);
  document.addEventListener('shopify:section:load', runInit);
  if (window.PUB_SUB_EVENTS && window.subscribe && window.PUB_SUB_EVENTS.cartUpdate) {
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, runInit); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var cta = e.target && e.target.closest ? e.target.closest('[data-rv2-scroll-upsell]') : null;
    if (cta) {
      e.preventDefault();
      var drawer = document.getElementById(DRAWER_ID);
      var carousel = drawer && (drawer.querySelector('.rv2-upsell') || drawer.querySelector('.cart-drawer-upsells-container'));
      if (carousel && carousel.scrollIntoView) carousel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
      return;
    }

    var card = e.target && e.target.closest ? e.target.closest('.rv2-upsell__card[data-product-url]') : null;
    if (!card) return;
    if (e.target.closest('a, button, input, select, textarea, form, product-form')) return;
    var url = attr(card, 'data-product-url');
    if (url) window.location.href = url;
  });

  /* 15/09/2026 — bottone «Aggiungi il 2°/3° pack» della card tanga (snippets/rolvea-cart-upsell.liquid):
     alza la quantita' dell'ultima riga pagata; il sync sopra allinea omaggio e codice 2PACK. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-rv-tg-addpack]') : null;
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('data-busy')) return;
    b.setAttribute('data-busy', '1'); b.classList.add('is-busy');
    var key = attr(b, 'data-key'), qty = toInt(attr(b, 'data-qty'), 2);
    tgJson(tgRoot() + 'cart/change.js', { id: key, quantity: qty }).then(function () {
      return tgJson(tgRoot() + 'cart/update.js', { updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }).then(tgRender);
    }).catch(function () {}).then(function () {
      tgSync();
      b.removeAttribute('data-busy'); b.classList.remove('is-busy');
    });
  });

  /* 16/09/2026 — card cross-sell [data-rv-tgx] (una sola visibile: stato sessionStorage rv_tgx '' → card 0, 'p' → card 1,
     'd' → nessuna), chip colore/taglia → variante dalla mappa JSON della card, add.js, render, sync (applica TANGAPLUS). */
  var TGX_KEY = 'rv_tgx';
  function tgxState() { try { return window.sessionStorage.getItem(TGX_KEY) || ''; } catch (e) { return ''; } }
  function tgxSetState(v) { try { window.sessionStorage.setItem(TGX_KEY, v); } catch (e) {} }
  function tgxReveal(scope) {
    var cards = scope.querySelectorAll('[data-rv-tgx]');
    if (!cards.length) return;
    /* '' → solo la card 0 (leggings); 'p' → solo la card 1 (reggiseno, downsell dopo la ×); 'd' → nessuna.
       Se i leggings sono gia' in carrello la card 0 non viene stampata e NON si passa al reggiseno:
       un cross-sell accettato non ne apre un altro (una card per volta, detto a Michele). */
    var st = tgxState(), want = st === 'd' ? -1 : (st === 'p' ? 1 : 0);
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i], idx = toInt(attr(c, 'data-rv-tgx'), 0);
      if (idx === want) { c.removeAttribute('hidden'); tgxSyncBtn(c); }
      else c.setAttribute('hidden', '');
    }
  }
  function tgxVariant(card) {
    var map = null;
    try { var s = card.querySelector('[data-rv-tgx-map]'); map = s ? JSON.parse(s.textContent) : null; } catch (e) { map = null; }
    if (!map) return null;
    var id = map[attr(card, 'data-color') + '|' + attr(card, 'data-size')];
    return id ? id : null;
  }
  function tgxSyncBtn(card) {
    var b = card.querySelector('[data-rv-tgx-add]');
    if (!b) return;
    if (tgxVariant(card)) b.removeAttribute('disabled'); else b.setAttribute('disabled', '');
  }
  document.addEventListener('click', function (e) {
    var t = e.target, card = t && t.closest ? t.closest('[data-rv-tgx]') : null;
    if (!card) return;
    var sw = t.closest('[data-rv-tgx-color]'), chip = t.closest('[data-rv-tgx-size]'), x = t.closest('[data-rv-tgx-close]'), add = t.closest('[data-rv-tgx-add]');
    if (sw) {
      e.preventDefault();
      card.setAttribute('data-color', attr(sw, 'data-rv-tgx-color'));
      var sws = card.querySelectorAll('[data-rv-tgx-color]');
      for (var i = 0; i < sws.length; i++) sws[i].classList.toggle('is-on', sws[i] === sw);
      tgxSyncBtn(card); return;
    }
    if (chip) {
      e.preventDefault();
      card.setAttribute('data-size', attr(chip, 'data-rv-tgx-size'));
      var chips = card.querySelectorAll('[data-rv-tgx-size]');
      for (var k = 0; k < chips.length; k++) chips[k].classList.toggle('is-on', chips[k] === chip);
      tgxSyncBtn(card); return;
    }
    if (x) {
      e.preventDefault();
      tgxSetState(toInt(attr(card, 'data-rv-tgx'), 0) === 0 ? 'p' : 'd');
      card.setAttribute('hidden', '');
      tgxReveal(document.getElementById(DRAWER_ID) || document);
      return;
    }
    if (add) {
      e.preventDefault();
      if (add.getAttribute('data-busy')) return;
      var vid = tgxVariant(card);
      if (!vid) return;
      add.setAttribute('data-busy', '1'); add.classList.add('is-busy');
      tgJson(tgRoot() + 'cart/add.js', { items: [{ id: vid, quantity: 1, properties: { _src: 'drawer' } }] }).then(function () {
        return tgJson(tgRoot() + 'cart/update.js', { updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }).then(tgRender);
      }).catch(function () {}).then(function () {
        tgSync();
        add.removeAttribute('data-busy'); add.classList.remove('is-busy');
      });
    }
  });

  /* 16/09/2026 — card PACK FRATELLI [data-rv-tgp] (snippets/rolvea-cart-upsell.liquid in modalita' tanga e
     sections/rolvea-pureline-xsell.liquid sotto il buybox): chip taglia/colore → variante dalla mappa JSON "Colore|TAGLIA",
     /cart/add.js del pack PAGATO; poi tgSync aggiunge da solo il pack omaggio (coppia dal metafield) e allinea i codici.
     Dalla PDP il drawer viene aperto dopo il render. */
  function tgpVariant(card) {
    var map = null;
    try { var s = card.querySelector('[data-rv-tgp-map]'); map = s ? JSON.parse(s.textContent) : null; } catch (e) { map = null; }
    if (!map) return null;
    var id = map[attr(card, 'data-color') + '|' + attr(card, 'data-size')];
    return id ? id : null;
  }
  function tgpSyncBtn(card) {
    var b = card.querySelector('[data-rv-tgp-add]');
    if (!b) return;
    if (tgpVariant(card)) b.removeAttribute('disabled'); else b.setAttribute('disabled', '');
  }
  document.addEventListener('click', function (e) {
    var t = e.target, card = t && t.closest ? t.closest('[data-rv-tgp]') : null;
    if (!card) return;
    var sw = t.closest('[data-rv-tgp-color]'), chip = t.closest('[data-rv-tgp-size]'), add = t.closest('[data-rv-tgp-add]');
    if (sw) {
      e.preventDefault();
      card.setAttribute('data-color', attr(sw, 'data-rv-tgp-color'));
      var sws = card.querySelectorAll('[data-rv-tgp-color]');
      for (var i = 0; i < sws.length; i++) sws[i].classList.toggle('is-on', sws[i] === sw);
      tgpSyncBtn(card); return;
    }
    if (chip) {
      e.preventDefault();
      card.setAttribute('data-size', attr(chip, 'data-rv-tgp-size'));
      var chips = card.querySelectorAll('[data-rv-tgp-size]');
      for (var k = 0; k < chips.length; k++) chips[k].classList.toggle('is-on', chips[k] === chip);
      tgpSyncBtn(card); return;
    }
    if (add) {
      e.preventDefault();
      if (add.getAttribute('data-busy')) return;
      var vid = tgpVariant(card);
      if (!vid) return;
      add.setAttribute('data-busy', '1'); add.classList.add('is-busy');
      var inDrawer = !!card.closest('#' + DRAWER_ID);
      /* omaggio PRIMA e pagato DOPO nella stessa add.js (come il form della PDP): Shopify mette in cima l'ultima riga
         aggiunta, cosi' nel drawer la riga pagata sta sopra e l'omaggio sotto. Senza l'id omaggio si aggiunge solo il
         pagato e ci pensa tgSync. Titolo variante = "TAGLIA / Colore" (opzione 1 = Taglia su tutta la famiglia). */
      var omH = attr(card, 'data-om'), vt = attr(card, 'data-size') + ' / ' + attr(card, 'data-color');
      tgpJust = { handle: attr(card, 'data-handle'), label: attr(card, 'data-added') || '\u2713', clickedAt: Date.now(), until: 0, scrolled: false };
      var pre = omH ? tgOmMap(omH).catch(function () { return {}; }) : Promise.resolve({});
      pre.then(function (m) {
        var items = [];
        if (m && m[vt]) items.push({ id: m[vt], quantity: 1, properties: { _gift: 'true' } });
        items.push({ id: vid, quantity: 1, properties: { _src: inDrawer ? 'drawer' : 'pdp' } });
        return tgJson(tgRoot() + 'cart/add.js', { items: items });
      }).then(function () {
        return tgJson(tgRoot() + 'cart/update.js', { updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }).then(tgRender);
      }).catch(function () {}).then(function () {
        tgSync();
        add.removeAttribute('data-busy'); add.classList.remove('is-busy');
        if (!inDrawer) {
          var d = document.querySelector('cart-drawer');
          try { if (d && typeof d.open === 'function' && !d.classList.contains('active')) d.open(); } catch (err) {}
        }
      });
    }
  });

  /* 19/09/2026 notte — feedback del quick-add «+ Aggiungi» (Clarity: 6 tap flaggati dead, la card sparisce dal carosello e la
     riga nuova compare in cima al drawer senza che la cliente lo veda): dopo ogni render, per ~5 s, la riga appena aggiunta
     porta una spilla «✓ Aggiunto» (testo dalla card, 5 lingue) e il drawer scorre fino a lei una volta sola. */
  var tgpJust = null;
  var tgpCssDone = false;
  function tgpFlash(scope) {
    if (!tgpJust) return;
    var now = Date.now();
    if (tgpJust.until && now > tgpJust.until) { tgpJust = null; return; }
    if (!tgpJust.until && now - tgpJust.clickedAt > 15000) { tgpJust = null; return; }
    var row = scope.querySelector('.cart-item--product-' + tgpJust.handle + '.rv-pl-paid, .cart-item--product-' + tgpJust.handle);
    if (!row) return;
    /* la finestra dei 4 s parte dal PRIMO render in cui la riga esiste, non dal tap (il giro add → render → sync dura 2-4 s) */
    if (!tgpJust.until) tgpJust.until = now + 4000;
    if (!tgpCssDone) {
      tgpCssDone = true;
      var st = document.createElement('style');
      st.textContent = '.rv-just-added{box-shadow:0 0 0 2px #1f7a3f inset;border-radius:10px}.rv-added-badge{display:inline-block;margin:0 0 4px;font-size:11px;font-weight:800;letter-spacing:.02em;color:#fff;background:#1f7a3f;border-radius:999px;padding:2px 9px;line-height:1.4}';
      document.head.appendChild(st);
    }
    row.classList.add('rv-just-added');
    if (!row.querySelector('.rv-added-badge')) {
      var b = document.createElement('span'); b.className = 'rv-added-badge'; b.textContent = tgpJust.label;
      var name = row.querySelector('.cart-item__name, .cart-drawer-item__name, .cart-item__details');
      if (name && name.parentNode) name.parentNode.insertBefore(b, name); else row.insertBefore(b, row.firstChild);
    }
    if (!tgpJust.scrolled) {
      tgpJust.scrolled = true;
      try { row.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { try { row.scrollIntoView(true); } catch (e2) {} }
    }
    var left = tgpJust.until - Date.now();
    setTimeout(function () {
      var r = document.querySelector('.rv-just-added'); if (r) r.classList.remove('rv-just-added');
      var bb = document.querySelector('.rv-added-badge'); if (bb && bb.parentNode) bb.parentNode.removeChild(bb);
    }, left > 0 ? left : 0);
  }

  /* 19/09/2026 notte — «−» a quantità 1 sulle righe pack Pureline: il tema lo ignora (min=1) e la cliente lo tocca fino a
     4 volte (Clarity). Ora a quantità minima il «−» toglie la riga come il cestino (l'omaggio segue col sync). */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.quantity__button--minus, .quantity__button[name="minus"]') : null;
    if (!b) return;
    var row = b.closest('.cart-drawer-item, .cart-item'); if (!row || !row.classList.contains('rv-pl-paid')) return;
    var inp = row.querySelector('.quantity__input'); if (!inp) return;
    var v = parseInt(inp.value, 10), min = parseInt(inp.min, 10);
    if (isNaN(v)) return; if (isNaN(min) || min < 1) min = 1;
    if (v > min) return;
    e.preventDefault(); e.stopPropagation();
    if (row.getAttribute('data-rv-minus-busy')) return;
    row.setAttribute('data-rv-minus-busy', '1');
    /* il valore a schermo puo' essere vecchio (render intermedi dopo un «+»): la quantita' vera si legge da /cart.js */
    var vid = String(attr(inp, 'data-quantity-variant-id') || '');
    tgJson(tgRoot() + 'cart.js').then(function (cart) {
      var it = null, items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var p = items[i].properties || {};
        if (String(items[i].variant_id) === vid && p._gift !== 'true') { it = items[i]; break; }
      }
      if (!it) return;
      if (it.quantity > 1) {
        var real = document.querySelector('#' + DRAWER_ID + ' .quantity__input[data-quantity-variant-id="' + vid + '"]');
        if (real) { real.value = String(it.quantity - 1); real.dispatchEvent(new Event('change', { bubbles: true })); }
        return;
      }
      var rm = row.querySelector('cart-remove-button button') || row.querySelector('cart-remove-button');
      if (rm && rm.isConnected !== false) rm.click();
      else return tgJson(tgRoot() + 'cart/change.js', { id: it.key, quantity: 0 }).then(function () { return tgJson(tgRoot() + 'cart/update.js', { updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }).then(tgRender); }).then(function () { tgSync(); });
    }).catch(function () {}).then(function () { row.removeAttribute('data-rv-minus-busy'); });
  }, true);

  /* carosello pack fratelli: l'invito «scorri →» sparisce al primo scroll (o subito se non c'e' niente da scorrere) */
  function tgpWire(scope) {
    var tracks = scope.querySelectorAll('[data-rv-tgp-track]');
    for (var i = 0; i < tracks.length; i++) {
      (function (track) {
        if (track.hasAttribute(DONE)) return;
        track.setAttribute(DONE, '1');
        var root = track.closest ? track.closest('.rv-tgps') : null;
        var hint = root ? root.querySelector('[data-rv-tgp-hint]') : null;
        if (!hint) return;
        if (track.scrollWidth <= track.clientWidth + 8) { hint.classList.add('is-hidden'); return; }
        var onScroll = function () { if (track.scrollLeft > 8) { hint.classList.add('is-hidden'); track.removeEventListener('scroll', onScroll); } };
        track.addEventListener('scroll', onScroll, { passive: true });
      })(tracks[i]);
    }
  }
  if (document.readyState !== 'loading') tgpWire(document); else document.addEventListener('DOMContentLoaded', function () { tgpWire(document); });

  window.RolveaCartV2 = { init: runInit, tangaSync: tgSync, tangaXsell: tgxReveal };
})();
